<script>
import Multiselect from "vue-multiselect";
import {formatAddress} from "../../helpers/inventories";

import api from "../../services/api";
import AddressForm from "../addresses/address-form";

/**
 * Nav-bar Component
 */
export default {
  components: {AddressForm, Multiselect},
  props: {
    inventory: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      listNumerisations: [],
      listSupports: [],
      listFormats: [],
      listLocations: [],
      listCommunes: [],
      listCountry: [],
      listAddresses: [],
      listPersons: [],
      addressReadOnly: false,
    };
  },
  beforeMount() {
    // todo fonction plus générique pour gérer ça
    //
    if (sessionStorage.getItem('numerisations'))
      this.listNumerisations = JSON.parse(sessionStorage.getItem('numerisations'));
    else {
      api.get('numerisations').then((response) => {
        this.listNumerisations = response.data.data;
        sessionStorage.setItem('numerisations', JSON.stringify(this.listNumerisations));

        return this.listNumerisations;
      });
    }

    if (sessionStorage.getItem('supports'))
      this.listSupports = JSON.parse(sessionStorage.getItem('supports'));
    else {
      api.get('supports').then((response) => {
        this.listSupports = response.data.data;
        sessionStorage.setItem('supports', JSON.stringify(this.listSupports));

        return this.listSupports;
      });
    }

    if (sessionStorage.getItem('formats'))
      this.listFormats = JSON.parse(sessionStorage.getItem('formats'));
    else {
      api.get('formats').then((response) => {
        this.listFormats = response.data.data;
        sessionStorage.setItem('formats', JSON.stringify(this.listFormats));

        return this.listFormats;
      });
    }

    if (sessionStorage.getItem('locations'))
      this.listLocations = JSON.parse(sessionStorage.getItem('locations'));
    else {
      api.get('addresses', {sortBy: 'name', page: 1, name: true}).then((response) => {
        this.listLocations = response.data.data;
        sessionStorage.setItem('locations', JSON.stringify(this.listLocations));

        return this.listLocations;
      });
    }

    if (sessionStorage.getItem('persons'))
      this.listPersons = JSON.parse(sessionStorage.getItem('persons'));
    else {
      api.get('persons').then((response) => {
        this.listPersons = response.data.data;
        sessionStorage.setItem('persons', JSON.stringify(this.listPersons));

        return this.listPersons;
      });
    }

    // création date par defaut si pas de date dans le model
    //
    if (!this.inventory.date) {
      this.inventory.date = {
        day: null,
        month: null,
        year: null,
      }
    }

    // création adresse par defaut si pas d'adresse dans le model
    //
    if (!this.inventory.address) {
      this.inventory.address = {
        commune_id: null,
        country_id: null,
        street: '',
        name: '',
      }
    }

    if (this.inventory.address.name && this.inventory.address.name !== "")
      this.addressReadOnly = true;
  },
  methods: {
    async submitForm() {

      // on n'envoi pas l'id pour que l'api recréé la liaison si la nouvelle adresse existe déjà
      //
      delete this.inventory.address.id;

      api.save('inventories', this.inventory)
          .then((response) => {
            if (response.status !== 200)
              this.$emit('error');
            else
              this.$emit('submitted');
          })
          .catch(() => {
            this.$emit('error');
          });
    },
    formatSelectListPersons(person) {
      return `${person.last_name} ${person.first_name}`
    },
    locationChanged(value) {
      if (value === null) {
       this.inventory.address = {
         name: '',
         street: '',
         commune: '',
         country: '',
       }

        this.addressReadOnly = false;
      }
      else
        this.addressReadOnly = true;
    },
    formatAddress(location) {
      return formatAddress(location, false);
    },
  }
};
</script>

<template>

  <b-form>
    <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
      <b-tab active>
        <template v-slot:title>
          <span class="d-none d-sm-inline-block">Général</span>
        </template>
        <b-card no-body class="mb-2 pt-2">
          <b-card-body class="p-0">
            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Numero inventaire" label-for="formrow-NumeroInv-input">
                  <b-form-input id="formrow-NumeroInv-input" type="text"
                                v-model="inventory.inventory_number"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Numero" label-for="formrow-Numero-input">
                  <b-form-input id="formrow-Numero-input" type="text"
                                v-model="inventory.exploitation_number"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Titre" label-for="formrow-titre-input">
                  <b-form-textarea id="formrow-titre-input"
                                   v-model="inventory.title"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Jour" label-for="formrow-jour-input">
                  <b-form-input id="formrow-jour-input" type="number" min="0" max="31"
                                v-model="inventory.date.day"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Mois" label-for="formrow-mois-input">
                  <b-form-input id="formrow-mois-input" type="number" min="0" max="12"
                                v-model="inventory.date.month"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Année" label-for="formrow-annee-input">
                  <b-form-input id="formrow-annee-input" type="number" min="0"
                                v-model="inventory.date.year"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Lieu" label-for="formrow-lieu-input">
                  <multiselect
                      id="formrow-lieu-input"
                      v-model="inventory.address"
                      :options="listLocations"
                      label="name"
                      track-by="id"
                      :show-labels="false"
                      @input="locationChanged"
                  >
                    <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.name }}</strong> <small>
                      {{ formatAddress(option) }}</small></template>
                    <template slot="option" slot-scope="props">
                      <strong>{{ props.option.name }}</strong> <small>
                      {{ formatAddress(props.option) }}</small>
                    </template>
                  </multiselect>
                </b-form-group>
              </b-col>

              <address-form :address="inventory.address" :read-only="addressReadOnly"></address-form>

            </b-row>

            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Observations" label-for="formrow-observations-input">
                  <b-form-textarea id="formrow-observations-input" type="text"
                                   v-model="inventory.observations"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-tab>

      <b-tab>
        <template v-slot:title>
          <span class="d-none d-sm-inline-block">Personnes</span>
        </template>
        <b-card no-body class="mb-2 pt-2">
          <b-card-body class="p-0" title="">
            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Présentes sur la photo" label-for="formrow-personnes-input">
                  <multiselect
                      id="formrow-personnes-input"
                      v-model="inventory.persons"
                      :options="listPersons"
                      label="last_name"
                      track-by="id"
                      select-label=""
                      :multiple="true"
                      :custom-label="formatSelectListPersons"
                      :show-labels="false"
                  >
                  </multiselect>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Auteur" label-for="formrow-auteur-input">
                  <multiselect
                      id="formrow-auteur-input"
                      v-model="inventory.authors"
                      :options="listPersons"
                      label="last_name"
                      track-by="id"
                      select-label=""
                      :multiple="true"
                      :custom-label="formatSelectListPersons"
                      :show-labels="false"
                  >
                  </multiselect>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-tab>

      <b-tab>
        <template v-slot:title>
          <span class="d-none d-sm-inline-block">Technique</span>
        </template>
        <b-card no-body class="mb-2 pt-2">
          <b-card-body class="p-0">
            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Format" label-for="formrow-format-input">
                  <multiselect
                      id="formrow-format-input"
                      v-model="inventory.format"
                      :options="listFormats"
                      label="string"
                      track-by="id"
                      :show-labels="false"
                  >
                  </multiselect>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Support" label-for="formrow-support-input">
                  <multiselect
                      id="formrow-support-input"
                      v-model="inventory.support"
                      :options="listSupports"
                      label="title"
                      track-by="id"
                      :show-labels="false"
                  >
                  </multiselect>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Numérisation" label-for="formrow-numerisation-input">
                  <multiselect
                      id="formrow-numerisation-input"
                      v-model="inventory.numerisation"
                      :options="listNumerisations"
                      label="title"
                      track-by="id"
                      :show-labels="false"
                  >
                  </multiselect>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Constat d'état" label-for="formrow-state_report-input">
                  <b-form-textarea id="formrow-state_report-input" type="text"
                                   v-model="inventory.state_report"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-tab>
    </b-tabs>


    <div class="text-right">
      <b-button variant="primary" @click="submitForm">Enregistrer</b-button>
      <b-button variant="secondary" @click="$emit('cancel')">Annuler</b-button>
    </div>
  </b-form>
</template>